import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

export class ApiDigitalAuthCatalog {
  static apiResponse: ApiResponse

  // Server route: routes.ts:256 — GET /:apikey/addons
  // Guards: checkServiceApiKey + idUserJWT
  // Response: { addons: IAddOn[] }
  public static async getAddOns(
    api_key: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/addons`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: null
      }
    })

    return this.apiResponse
  }

  // Server route: GET /:apikey/addons/for-plan?plan_id=X&billing_cycle=monthly|yearly
  // Guards: checkServiceApiKey + idUserJWT
  // Response: { addons: CatalogAddOn[] }
  // Error: ADDON_NO_PRICE_FOR_CYCLE if an add-on has no pricing for the requested cycle
  public static async getAddonsForPlan(
    api_key: string,
    plan_id: string,
    billing_cycle: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/addons/for-plan?plan_id=${encodeURIComponent(plan_id)}&billing_cycle=${encodeURIComponent(billing_cycle)}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }

  // Server route: routes.ts:239 — GET /:apikey/plans
  // Guards: checkServiceApiKey + idUserJWT
  // Response: { plans[], current_plan_id, current_billing_cycle, current_period_end, vocabulary }
  // direction{} and effective_date{} are dictionaries on each plan, keyed by billing_cycle
  public static async getPlans(
    api_key: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/plans`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: null
      }
    })

    return this.apiResponse
  }
}
